function passthrough() {
  return new Response(null, {
    status: 302,
    statusText: "Passthrough",
    headers: {
      "x-msw-intention": "passthrough"
    }
  });
}
export {
  passthrough
};
//# sourceMappingURL=passthrough.mjs.map